import { render, staticRenderFns } from "./AlignGridIndicator.vue?vue&type=template&id=558b1610&"
import script from "./AlignGridIndicator.vue?vue&type=script&lang=ts&"
export * from "./AlignGridIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./AlignGridIndicator.vue?vue&type=style&index=0&id=558b1610&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports